/* eslint-disable max-classes-per-file */
import { Directive, Input, OnInit, Optional, TemplateRef, ViewContainerRef } from '@angular/core';

export class AliasContext<T> {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, no-null/no-null
  public emAlias: T = null!;

  public get $implicit(): T {
    return this.emAlias;
  }
}

/**
 * Unconditionally renders the template, aliasing a potentially complex expression to a simpler
 * template input variable. Unlike `*ngIf ... as`, it renders even when the value is falsy.
 */
@Directive({
  selector: '[emAlias]',
  standalone: false,
})
export class AliasDirective<T> implements OnInit {
  private readonly context = new AliasContext<T>();

  public constructor(
    private readonly viewContainer: ViewContainerRef,
    @Optional() private readonly templateRef: TemplateRef<unknown>
  ) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!this.templateRef) {
      throw new Error(`[emAlias] can only be used as a structural directive or on an ng-template.`);
    }
  }

  public static ngTemplateContextGuard<T>(
    directive: AliasDirective<T>,
    context: unknown
  ): context is AliasContext<T> {
    return true;
  }

  public ngOnInit(): void {
    this.viewContainer.createEmbeddedView(this.templateRef, this.context);
  }

  @Input()
  public set emAlias(expression: T) {
    this.context.emAlias = expression;
  }
}
